import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";

const BOOTSTRAP = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
const BUSINESS_UNIT_ID = process.env.REACT_APP_TRUSTPILOT_BUSINESS_UNIT_ID || "69c7cd63842d186fc807b112";
const TEMPLATE_ID = process.env.REACT_APP_TRUSTPILOT_TEMPLATE_ID || "56278e9abfbbba0bdcd568bc";
const PROFILE_URL = process.env.REACT_APP_TRUSTPILOT_PROFILE_URL || "https://www.trustpilot.com/review/senior-stylist.com";
const LOCALE = process.env.REACT_APP_TRUSTPILOT_LOCALE || "en-US";
const TOKEN = process.env.REACT_APP_TRUSTPILOT_TOKEN || "ce886926-b371-4152-b5ea-a1a7b9523279";

function loadScript() {
  if (window.Trustpilot?.loadFromElement) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${BOOTSTRAP}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("tp")), { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = BOOTSTRAP;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("tp"));
    document.head.appendChild(s);
  });
}

// Official Trustpilot free-plan Review Collector. Renders the genuine TrustBox once a
// Business Unit ID is configured; until then it shows a compliant plain text link (no
// logo, stars or TrustScore, per Trustpilot free-plan brand rules).
export const TrustpilotReviewCollector = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (!BUSINESS_UNIT_ID) return;
    let cancelled = false;
    loadScript()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!BUSINESS_UNIT_ID) {
    return (
      <a
        href={PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="trustpilot-review-collector-link"
        className="group inline-flex items-center justify-center gap-2 rounded-full border border-stylist-ink/25 px-7 py-4 text-sm text-stylist-ink hover:bg-stylist-ink hover:text-white transition-colors duration-300"
      >
        Leave a review on Trustpilot
        <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    );
  }

  return (
    <div
      ref={ref}
      className="trustpilot-widget mx-auto w-full max-w-md"
      data-locale={LOCALE}
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-height="52px"
      data-style-width="100%"
      data-token={TOKEN}
      data-theme="light"
      data-testid="trustpilot-review-collector"
    >
      <a
        href={PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center justify-center gap-2 rounded-full border border-stylist-ink/25 px-7 py-4 text-sm text-stylist-ink hover:bg-stylist-ink hover:text-white transition-colors duration-300"
      >
        Leave a review on Trustpilot
        <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    </div>
  );
};
